import api from './client';

export const getContacts = (params) => api.get('/contacts', { params });
export const getContact = (id) => api.get(`/contacts/${id}`);
export const createContact = (data) => api.post('/contacts', data);
export const updateContact = (id, data) => api.put(`/contacts/${id}`, data);
export const archiveContact = (id) => api.patch(`/contacts/${id}/archive`);
export const unarchiveContact = (id) => api.patch(`/contacts/${id}/unarchive`);
export const blockContact = (id) => api.patch(`/contacts/${id}/block`);
